import { useEffect, useRef, useState, useContext, useMemo } from 'react';
import styles from './index.module.scss'
import CanvasLeftCom from './canvasLeftCom'
import CanvasRightComCrop from './canvasRightComCrop'
import CanvasRightComFill from './canvasRightComFill'
import CanvasPreLoad from './canvasPreLoad'
import { RESIZE_IMG_CANVASNAME } from '@utils/CONST'
import { ImageResizeContext } from '../imageResizeContext'
// import WaitUploadPage from '@view/compoents/WaitUploadPage2';
import WaitUploadPage from '@view/page_v3/AiEdit/components/WaitUploadPage2';
import Example from '@assets/json/examplev3.json'
import Utils from "@utils/utils";
import { UPLOAD_SOURCE } from "@utils/CONST";
import API from "@api/api";
import LoadingCom from '../components/loadingCom'
import { InfoCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import { AppContext } from '@utils/AppContext';
import ImageResizeBottomToolbar from '../components/bottomToolbar';

const AI_EDIT_UPLOAD_BG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/AIEdit/uploadBg/';

const ResizePageRight = (props) => {
    const { setGlobalLoading, AIEditRecentTaskId } = useContext(AppContext);
    const {
        showCropType, zoom, setZoom,
        initMinZoom, setInitMinZoom,
        initLeftCanvasZoom, setInitLeftCanvasZoom,
        initRightCanvasZoom, setInitRightCanvasZoom,
        imageUrl, setImageUrl,
        handleLoading, setHandleLoading,
        downBtnLoading,
        resizeResult, setResizeResult,
        imgWidth, imgHeight,
        targetSsize, setTargetSize,
        setSelectedKey,
        AIEditTemTaskId,
        setDownBtnLoading
    } = useContext(ImageResizeContext)

    const rightCropRef = useRef()
    const rightFillRef = useRef()
    const leftCanvasRef = useRef()
    const imgMaxLimit = useRef(4096)


    const [exampleList] = useState(Example)
    const modelExamples = useMemo(() => {
        const list = ['示例1-女士黑色短袖', '商品示例2', '商品示例3']
        return list.map(name => exampleList.find(item => item.name == name))
    }, [exampleList])


    const handleZoom = (scale, canvasName) => {
        if (!initMinZoom) {
            if (canvasName === RESIZE_IMG_CANVASNAME.LEFT_CANVAS_NAME) {
                setInitLeftCanvasZoom(scale);
            } else if (canvasName === RESIZE_IMG_CANVASNAME.RIGHT_CANVAS_NAME) {
                setInitRightCanvasZoom(scale);
            }
        }
        if (canvasName == RESIZE_IMG_CANVASNAME.SCROLL_CANVAS) {
            setZoom(scale)
        }
    };


    useEffect(() => {
        if (!initLeftCanvasZoom || !initRightCanvasZoom) return;
        const calcMinZoom = Math.min(initLeftCanvasZoom || 1, initRightCanvasZoom || 1);
        setInitMinZoom(calcMinZoom);
        setHandleLoading(false)
    }, [initLeftCanvasZoom, initRightCanvasZoom]);


    const handleMove = (newPos, source) => {
        if (source !== 'RIGHT' && rightCropRef.current) rightCropRef.current.setPosition(newPos)
        if (source !== 'RIGHT' && rightFillRef.current) rightFillRef.current.setPosition(newPos)
        if (source !== 'LEFT' && leftCanvasRef.current) leftCanvasRef.current.setPosition(newPos)
    };

    const uploadConfirm = (type, { title, content, okText, cancelText, maskClosable, onOk = () => { }, onCancel = () => { } }) => {
        return new Promise((resolve) => {
            PSAIModal.confirm({
                title: title,
                content: content,
                closable: false,
                icon: <InfoCircleOutlined style={{ color: "#FF864C" }} />,
                centered: true,
                maskClosable: maskClosable,
                okText: okText,
                cancelText: cancelText,
                async onOk() {
                    try {
                        const res = await onOk()
                        resolve(res)
                    } catch (err) {
                        console.log('onOk reject', err)
                        resolve(false)
                        throw err
                    }
                },
                async onCancel() {
                    try {
                        const res = await onCancel()
                        console.log('onCancel', res)
                        resolve(res)
                    } catch (err) {
                        console.log('onCancel reject', err)
                        resolve(false)
                        throw err
                    }
                },
                async onClose() {
                    resolve(false)
                }
            })
        })
    }

    const beforeUpload = async (file) => {
        try {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp' || file.type === 'image/avif';
            if (!isJpgOrPng) throw new Error('您只能上传JPG/PNG/WEBP/AVIF格式的文件')
            setGlobalLoading("上传中...")

            const validate = await Utils.validateImageFile(file)
            if (!validate) return false

            const { width, height } = await Utils.getImageDimensions(file)
            if ((width > imgMaxLimit.current || height > imgMaxLimit.current)) {
                setGlobalLoading(false)
                await uploadConfirm('confirm', {
                    title: '图片过大',
                    content: `为您调整尺寸后可打开, 分辨率 ≤ ${imgMaxLimit.current}*${imgMaxLimit.current}`,
                    okText: '调整并打开',
                    cancelText: '重新上传',
                    onOk: async () => {
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, imgMaxLimit.current)
                        if (resizeRes && resizeRes.success) {
                            beforeUpload(resizeRes.file)
                        } else {
                            message.warning(resizeRes.message)
                        }
                    },
                    onCancel: async () => {
                        const res = await Utils.openFile2(true)
                        if (res) {
                            beforeUpload(res[0])
                        }
                    }
                })
                return false
            } else {
                if (file) {
                    const res = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.EXTRACTION)
                    if (!res) return false
                    if (!res.isLegal) {
                        setGlobalLoading(false)
                        PSAIModal.confirm({
                            content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                            okText: '继续上传',
                            cancelText: '取消',
                            onOk() { Utils.openFile2(true).then(beforeUpload).catch(() => { }) },
                            onCancel() { },
                        })
                        return false
                    }
                    setGlobalLoading(false)
                    setImageUrl(res.data)
                    clearCache()
                }
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setGlobalLoading(false)
            return false
        }
    }

    const uploadChange = (url) => {
        clearCache()
        setImageUrl(url)
    }

    const clearCache = () => {
        setResizeResult([])
        setTargetSize([])
        setInitLeftCanvasZoom()
        setInitRightCanvasZoom()
        setInitMinZoom()
        setSelectedKey()
        props.reUpload()
    }

    const handleRemove = () => {
        clearCache()
        sessionStorage.removeItem('imgResizeCache')
        setImageUrl()
        props.handleCleanClick?.()
    }

    const getUrlParam = () => {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const urlParams = new URLSearchParams(urlObj.search);
        if (urlParams.has('url')) {
            return urlParams.get('url');
        }
        return null;
    };

    useEffect(() => {
        setTimeout(() => {
            const imageUrlFromParam = getUrlParam();
            if (!imageUrlFromParam) return
            clearCache()
            setImageUrl(imageUrlFromParam)
        }, 200)
    }, [])


    const selectImgResultWhichOne = useMemo(() => {
        if(resizeResult.length <= 0) return
        return resizeResult[1]
    }, [resizeResult])

    const mainPage = (
        <>
            <CanvasLeftCom
                ref={leftCanvasRef}
                onMove={(pos) => handleMove(pos, 'LEFT')}
                onZoom={handleZoom}
                key={selectImgResultWhichOne + 'ori'}
                zoom={zoom}
                initMinZoom={initMinZoom}
                imageUrl={imageUrl} />
            <div className={styles.dividerLine}></div>
            {
                showCropType ? <CanvasRightComCrop
                    ref={rightCropRef}
                    key={selectImgResultWhichOne + 'crop'}
                    onMove={(pos) => handleMove(pos, 'RIGHT')}
                    onZoom={handleZoom}
                    zoom={zoom}
                    initMinZoom={initMinZoom}
                    rectWidth={targetSsize[1]}
                    rectHeight={targetSsize[0]}
                    imageUrl={selectImgResultWhichOne}
                /> : <CanvasRightComFill
                    key={selectImgResultWhichOne + 'fill'}
                    ref={rightFillRef}
                    onMove={(pos) => handleMove(pos, 'RIGHT')}
                    onZoom={handleZoom}
                    zoom={zoom}
                    initMinZoom={initMinZoom}
                    rectWidth={targetSsize[1]}
                    rectHeight={targetSsize[0]}
                    imageUrl={selectImgResultWhichOne}
                />
            }
        </>
    )

    const preLoadPage = (
        <CanvasPreLoad
            onMove={handleMove}
            onZoom={handleZoom}
            key={imageUrl}
            zoom={zoom}
            imageUrl={imageUrl}
        />
    )

    const uploadPage = (
        <WaitUploadPage
            btnText={"上传图片"}
            title="高清改尺寸"
            uploadTips={`请点击上方按钮添加图片或将图片拖拽至此区域内上传
500*500≤上传图片尺寸≤4096*4096`}
            placeholderCards={[
                {
                    title: '一键修改图片尺寸，完美适配不同平台',
                    image: `${AI_EDIT_UPLOAD_BG}imageResize.png`
                }
            ]}
            uploadExamples={modelExamples}
            pickFromProject={true}
            onUpload={beforeUpload}
            onChange={uploadChange}
            needLogin={true}
            showUpImg={imageUrl}
            showAllType
            imageSize={`${imgWidth}*${imgHeight}`}
        />
    )

    const downloadClick = (key) => {
        if (showCropType) {
            rightCropRef.current.cropImageByRegion(key)
        } else {
            rightFillRef.current.exportImageContainMode(key)
        }
    }

    const commonDownloadFunc = async () => {
        const status = Utils.checkLoginStatus(() => commonDownloadFunc())
        if (!status) return

        const taskId = AIEditTemTaskId || AIEditRecentTaskId
        if (!taskId) return

        setDownBtnLoading(true)
        try {
            const res = await API.commonDownload({ taskId })
            if (res?.code != 0) throw new Error(res?.message)
            Utils.downUrl(res.data, 'aiEdit')
            message.success('下载成功')
        } catch (err) {
            message.error(err.message)
        } finally {
            setDownBtnLoading(false)
        }
    }

    const hasRecentTaskResult = !!(AIEditTemTaskId || AIEditRecentTaskId)
    const showDownload = resizeResult.length > 0 || hasRecentTaskResult
    const handleDownload = resizeResult.length > 0 ? downloadClick : commonDownloadFunc
    const downloadBtnText = resizeResult.length > 0 ? '确认并下载' : '下载图片'

    useEffect(() => {
        if (!props.onBottomConfigChange) return

        if (!imageUrl) {
            props.onBottomConfigChange(null)
            return
        }

        props.onBottomConfigChange({
            customContent: (
                <ImageResizeBottomToolbar
                    onUpload={beforeUpload}
                    onChange={uploadChange}
                    onDownload={handleDownload}
                    onRemove={handleRemove}
                    showDownload={showDownload}
                    downloadBtnText={downloadBtnText}
                    downBtnLoading={downBtnLoading}
                    zoomValue={zoom || initMinZoom || 1}
                    onZoomChange={setZoom}
                />
            )
        })

        return () => {
            props.onBottomConfigChange(null)
        }
    }, [props.onBottomConfigChange, imageUrl, resizeResult.length, downBtnLoading, zoom, initMinZoom, setZoom, AIEditTemTaskId, AIEditRecentTaskId])

    return <div className={styles.resizePageRight}>
        {
            resizeResult.length > 0 ? mainPage : imageUrl ? preLoadPage : (
                <div className={styles.uploadPageShell}>
                    {uploadPage}
                </div>
            )
        }
        {handleLoading && <LoadingCom />}
    </div>
}

export default ResizePageRight
